import { defineStore } from 'pinia';
export const useDataAndGroupingStore = defineStore('dataAndGrouping', {
    state: () => ({
        // metric data ==> x axis
        metricData: [],
        // y-axis
        metricGroupings: [],
    }),
    getters: {
        getExistingMetricData() {
            return this.metricData;
        },
    },
    actions: {
        initateMetricData(existingMetricData) {
            if (!existingMetricData || existingMetricData.length <= 0) {
                this.addMetricData();
            } else {
                // load existing metricData
                this.metricData = this.loadExistingMetricData(existingMetricData);
            }
        },
        loadExistingMetricData(existingMetricData) {
            return existingMetricData.map((metric) => {
                let newMetric = {
                    label: metric.label ?? null,
                    assessment_code: metric.assessment_code ?? null,
                    attribute_code: metric.attribute_code ?? null,
                    type: metric.type ?? null,
                    tag_id: metric.tag_id ?? null, //api returns tag as object along so we will fetch the code from inside the object
                };
                // to set the selection type in the UI, check if tag is null or not, otherwise its an assessment/attribute type
                newMetric.selectedMode = newMetric.tag_id ? 'Tag' : 'Attribute';
                return newMetric;
            });
        },
        addMetricData() {
            // push a new empty object to the existing metricData everytime a metric data is added in the UI
            this.metricData?.push({
                label: null,
                assessment_code: null,
                attribute_code: null,
                type: null,
                tag_id: null,
                selectedMode: 'Tag',
            });
        },
        removeMetricData(metricDataIndex) {
            // filter out the given index from the existing currentAttributeFilters state
            this.metricData = this.metricData.filter((_, index) => index != metricDataIndex);
        },
        initateMetricGroupings(existingMetricGroupings, shared = false) {
            if (!existingMetricGroupings || existingMetricGroupings.length <= 0) {
                this.addMetricGrouping(shared);
            } else {
                this.metricGroupings = this.loadExistingMetricGroupings(existingMetricGroupings);
            }
        },
        loadExistingMetricGroupings(existingMetricGroupings) {
            return existingMetricGroupings.map((metricGroup) => {
                let newMetricGroup = {
                    label: metricGroup.label ?? null,
                    assessment_code: metricGroup.assessment_code ?? null,
                    attribute_code: metricGroup.attribute_code ?? null,
                    calendar_units: metricGroup.calendar_units ?? null,
                    calendar_qty: metricGroup.calendar_qty ?? null,
                    user_groups_id: metricGroup.user_groups_id ?? null,
                    user_id: metricGroup.user_id ?? null,
                    companies: metricGroup.companies ?? null,
                    my_company: metricGroup.my_company ?? null,
                };
                // set the selection type in the UI,
                if (newMetricGroup.assessment_code || newMetricGroup.attribute_code) {
                    newMetricGroup.selectedMode = 'Attribute';
                } else if (newMetricGroup.calendar_units || newMetricGroup.calendar_qty) {
                    newMetricGroup.selectedMode = 'Time Period';
                } else if (newMetricGroup.user_groups_id) {
                    newMetricGroup.selectedMode = 'User Group';
                } else if (newMetricGroup.user_id) {
                    newMetricGroup.selectedMode = 'User';
                } else if (newMetricGroup.companies && newMetricGroup.companies == 1) {
                    newMetricGroup.selectedMode = 'Pool Companies';
                } else if (newMetricGroup.my_company && newMetricGroup.my_company == 1) {
                    newMetricGroup.selectedMode = 'My Company';
                }
                return newMetricGroup;
            });
        },
        addMetricGrouping(shared) {
            // push a new empty object to the existing metricGroupings everytime metric grouping is added in the UI
            this.metricGroupings?.push({
                label: null,
                calendar_units: null,
                calendar_qty: null,
                assessment_code: null,
                attribute_code: null,
                user_groups_id: null,
                user_id: null,
                companies: null,
                my_company: null,
                selectedMode: shared ? 'User Group' : 'Time Period',
            });
        },
        removeMetricGrouping(metricGroupIndex) {
            // filter out the given index from the existing currentAttributeFilters state
            this.metricGroupings = this.metricGroupings.filter((_, index) => index != metricGroupIndex);
        },
        flushData() {
            this.metricData = [];
            this.metricGroupings = [];
        },
    },
});
